var target = window.location.hash;

// Converts anchor for accordions to plone anchor. (Replace umlaute with '-').
const accentsMap = new Map([
  [
    "-",
    "Á|À|Ã|Â|Ä|á|à|ã|â|ä|É|È|Ê|Ë|é|è|ê|ë|Í|Ì|Î|Ï|í|ì|î|ï|Ó|Ò|Ô|Õ|Ö|ó|ò|ô|õ|ö|Ú|Ù|Û|Ü|ú|ù|û|ü|Ç|ç|Ñ|ñ",
  ],
]);
const reducer = (acc, [key]) =>
  acc.replace(new RegExp(accentsMap.get(key), "g"), key);
export const slugify = (text) => [...accentsMap].reduce(reducer, text);

function isInt(value) {
  return (
    !isNaN(value) &&
    parseInt(Number(value)) == value &&
    !isNaN(parseInt(value, 10))
  );
}

// Helper to scroll in visible window
function _scrollTo(jquery_selector, yOffset) {
  var el = jquery_selector[0];
  if (el) {
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
}

// accordion with the first tab closed by default
var transformAccordion = function (content, selector, scroll) {
  var anker = location.hash.replace("#", "");
  var hash = parseInt(anker) || null;

  var empty_accordion = '<ul class="accordion"></ul>';
  var restart = false;
  var next_h2;
  var dest;

  if (!content) {
    var content = "#region-content, #content, #content-core"; // default fallback
  }
  var content_area = $(content);
  if (!content_area) {
    return;
  }

  if (!selector) {
    selector = "h2.accordion"; // default fallback
  }

  var search_headers = $(content_area).find(selector);
  if (!search_headers.length) {
    return;
  }

  $(search_headers).each(function (i) {
    // Convert to plone anker naming
    var title_text = slugify($(this).text().toLowerCase().replaceAll(" ", "-"));
    if (i == 0 || restart == true) {
      // Create a new accordion
      $(this).before(empty_accordion);
      dest = $(this).prev("ul.accordion");
      var li = $("<li>").addClass(
        "listing-cell listing-cell-collapse js-collapse",
      );
    } else {
      // Add just element for existing accordion
      var li = $("<li>").addClass(
        "listing-cell listing-cell-collapse js-collapse",
      );
    }
    // Add an id to find again (scroll)
    li.attr("id", title_text);
    li.attr("name", i);

    // Open the one with a hash
    if (i == hash) {
      li.addClass("active");
    }
    // Open the anker
    if (title_text === anker) {
      li.addClass("active");
    }
    // find out if a new accordion starts. Checks for h2 without selector
    if ($(this).nextAll("h2").length) {
      next_h2 = $(this).nextAll("h2")[0];
      // Empty h2 is the marker for a new starting accordion
      if (!$(next_h2).hasClass("accordion")) {
        $(next_h2).addClass("accordion-spacer");
        restart = true;
      } else {
        restart = false;
      }
    }

    var content_html = $("<div>").append($(this).nextUntil("h2")).html();

    var button = $('<button type="button">').addClass(
      "js-collapse-trigger link-outer ai-center chain-s",
    );
    var title = $("<span>")
      .addClass("cell-content d-flex ai-center")
      .html($(this).text());
    var icon = $("<span>").addClass("cell-icon");

    button.attr("rel", i);
    button.append(title);
    button.append(icon);
    button.on("click", function () {
      let current_accordion_li = $(this).parent().parent();
      if (current_accordion_li.prop("classList").contains("active")) {
        current_accordion_li.removeClass("active");
      } else {
        current_accordion_li.parent().find("li").removeClass("active");
        current_accordion_li.addClass("active");
        if (scroll) {
          _scrollTo($("#" + $.escapeSelector(title_text)), -100);
        }
      }
      location.hash = $(this).attr("rel");
    });

    li.append($("<div>").addClass("listing-cell-head py-xs").append(button));
    li.append(
      $("<div>")
        .addClass(
          "listing-cell-body js-collapse-content clip py-xs ai-center plain-txt",
        )
        .html(content_html),
    );

    $(this).remove();
    dest.append(li);
  });
};

transformAccordion(
  "#region-content, #content, #content-core",
  "h2.accordion",
  true,
);
transformAccordion(".metainfo-left", "h2.accordion", false);
transformAccordion(".metainfo-right", "h2.accordion", false);

// If the hash changes within the page, open the accordion
$(window).on("hashchange", function () {
  let hash = window.location.hash;
  let hash_raw = hash.substring(1);
  // Ignore the hashes with index
  if (isInt(hash_raw)) {
    return;
  }
  $(hash).addClass("active");
  $(hash).find(".listing-cell-body").eq(0).show();
  _scrollTo($(hash), -100);
});

// Wait for the accordion to be rendered
setTimeout(() => {
  var name_selector;
  var scroll_to;
  if (target) {
    if ($(target).length) {
      scroll_to = $(target);
    } else {
      if (target.includes("#")) {
        target = target.replace("#", "");
      }
      name_selector = $("[name=" + target + "]");
      if ($(name_selector).length) {
        scroll_to = name_selector;
      }
    }
  }
  if (scroll_to) {
    $(scroll_to).addClass("active");
    $(scroll_to).find(".listing-cell-body").eq(0).show();
    _scrollTo(scroll_to, -100);
  }
}, 500);
